// extracted by mini-css-extract-plugin
export var notificationHost = "_ds-0";